export const updateOrderShipment = /* GraphQL */ `
  mutation updateOrderShipment($input: UpdateOrderShipmentInput!) {
    updateOrderShipment(input: $input) {
      id
      messageStatus
    }
  }
`;

export const createDeviceToken = /* GraphQL */ `
  mutation createDeviceToken($input: CreateDeviceTokenInput!) {
    createDeviceToken(input: $input) {
      userId
      deviceToken
    }
  }
`;

export const updateCustomerUser = /* GraphQL */ `
  mutation updateCustomerUser($input: UpdateCustomerUserInput!) {
    updateCustomerUser(input: $input) {
      firstName
      middleName
      lastName
      email
      phoneNumber
      merchantAccountId
    }
  }
`;

export const createUser = /* GraphQL */ `
  mutation createMerchantUser($input: CreateMerchantUserInput!) {
    createMerchantUser(input: $input) {
      userId
      firstName
      lastName
      middleName
      email
      phoneNumber
      userRole
    }
  }
`;
export const createCustomerUser = /* GraphQL */ `
  mutation createCustomerUser($input: CreateCustomerUserInput!) {
    createCustomerUser(input: $input) {
      firstName
      lastName
      middleName
      email
      phoneNumber
      merchantAccountId
      errorMessage
    }
  }
`;

export const updateMerchantAccount = /* GraphQL */ `
  mutation updateMerchantAccount($input: UpdateMerchantAccountInput!) {
    updateMerchantAccount(input: $input) {
      id
    }
  }
`;

export const createStoreCustomerOrder = /* GraphQL */ `
  mutation createStoreCustomerOrder($input: createStoreCustomerOrderInput ){
    createStoreCustomerOrder(input: $input){
     id
    }
  }
`;

export const updateAddress = /* GraphQL */ `
  mutation updateAddress($input: UpdateMerchantAccountInput!) {
    updateMerchantAccount(input: $input) {
      id
      billingAddress {
        addrLine1
        addrLine1
        addrLine2
        addrLine3
        city
        country
        state
        country
        postCode
      }
    }
  }
`;



export const updateOrder = /* GraphQL */ `
  mutation updateOrder($input: UpdateOrderInput!) {
    updateOrder(input: $input) {
      id
    }
  }
`;

export const updateUser = /* GraphQL */ `
  mutation updateUser($input: UpdateMerchantUserInput!) {
    updateMerchantUser(input: $input) {
      userId
      firstName
      lastName
      userRole
      email
      phoneNumber
      address {
        addrLine1
        addrLine2
        city
        postCode
        country
        state
      }
    }
  }
`;

export const deleteCustomerUser = /* GraphQL */ `
  mutation deleteCustomerUser($input: DeleteCustomerUserInput!) {
    deleteCustomerUser(input: $input) {
      status
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation deleteMerchantUser($input: DeleteMerchantUserInput!) {
    deleteMerchantUser(input: $input) {
      userId
    }
  }
`;

export const bulkDeleteUser = /* GraphQL */ `
  mutation deleteMerchantUserBulk($input: DeleteMerchantUserBulkInput!) {
    deleteMerchantUserBulk(input: $input) {
      returnedIds
    }
  }
`;

export const bulkCustomerDeleteUser = /* GraphQL */ `
  mutation deleteCustomerUserBulk($input: DeleteCustomerUserBulkInput!) {
    deleteCustomerUserBulk(input: $input) {
      status
    }
  }
`;
export const createAddress = /* GraphQL */ `
  mutation CreateAddress(
    $input: CreateAddressInput!
    $condition: ModelAddressConditionInput
  ) {
    createAddress(input: $input, condition: $condition) {
      id
      addrLine1
      addrLine2
      addrLine3
      city
      state
      country
      postCode
      latitude
      longitude
      createdAt
      updatedAt
      owner
    }
  }
`;

export const deleteAddress = /* GraphQL */ `
  mutation DeleteAddress(
    $input: DeleteAddressInput!
    $condition: ModelAddressConditionInput
  ) {
    deleteAddress(input: $input, condition: $condition) {
      id
      addrLine1
      addrLine2
      addrLine3
      city
      state
      country
      postCode
      latitude
      longitude
      createdAt
      updatedAt
      owner
    }
  }
`;

export const createMerchantAccount = /* GraphQL */ `
  mutation CreateMerchantAccount($input: CreateMerchantAccountInput!) {
    createMerchantAccount(input: $input) {
      id
      companyName
      contactName
      contactPhoneNumber
      contactEmail
      # billingAddress {
      #   addrLine1
      #   addrLine2
      #   addrLine3
      #   city
      #   state
      #   country
      #   postCode
      #   latitude
      #   longitude
      # }
      accountStatus
      accountStatusReason
      approvedAt
      approvedBy
      Stores {
        nextToken
      }
    }
  }
`;

export const deleteMerchantAccount = /* GraphQL */ `
  mutation DeleteMerchantAccount(
    $input: DeleteMerchantAccountInput!
    $condition: ModelMerchantAccountConditionInput
  ) {
    deleteMerchantAccount(input: $input, condition: $condition) {
      id
      companyName
      contactName
      contactPhoneNumber
      contactEmail
      billingAddress {
        id
        addrLine1
        addrLine2
        addrLine3
        city
        state
        country
        postCode
        latitude
        longitude
        createdAt
        updatedAt
        owner
      }
      accountSatus
      accountStatusReason
      approvedAt
      approvedBy
      Stores {
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;

export const createStore = /* GraphQL */ `
  mutation CreateStore($input: CreateStoreInput!) {
    createStore(input: $input) {
      id
      storeRefId
      storeName
      storePhoneNumber
      storeEmail
      merchantAccountId
      storeStatus
      zipCode
      statusReason
      storePhotos
      statusUpdatedAt
      statusUpdatedBy
      users {
        items {
          user {
            firstName
            lastName
          }
          id
        }
      }
    }
  }
`;

export const UpdatePnaData = /* GraphQL */ `
  mutation UpdatePnaData($input: UpdatePnaDataInput){
    UpdatePnaData(input: $input){
    anyErrors
    }
  }
`
export const AddPnaData = /* GraphQL */ `
mutation AddPnaData($input: AddPnaDataInput){
    AddPnaData(input: $input){
        anyErrors
      }
    }
`

export const updateStore = /* GraphQL */ `
  mutation UpdateStore($input: UpdateStoreInput!) {
    updateStore(input: $input) {
      id
      deliveryFeeConfig {
        from
        to
        deliveryFee
      }
      customerConvenienceFeePercentage
      enableMerchantConvenienceFeePercentage
      enableConvenienceFeePercentage
      merchantConvenienceFeePercentage
       merchantFeeConfig {
         from
         to
         merchantFee
         merchantFeeToCustomer
      }
    }
  }
`;

export const updateStoreCustomerOrder = /* GraphQL */ `
  mutation updateStoreCustomerOrder($input: updateStoreCustomerOrderInput!) {
    updateStoreCustomerOrder(input: $input) {
      id
    }
  }
`;

export const updateServiceableStore = /* GraphQL */ `
  mutation UpdateStore($input: UpdateStoreInput!) {
    updateStore(input: $input) {
      id
      isPaused
      storeName
    }
  }
`;

export const isDeliveryPauseOrder = /* GraphQL */ `
  mutation UpdateStore($input: UpdateStoreInput!) {
    updateStore(input: $input) {
      id
      isDeliveryPaused
      storeName
    }
  }
`;

export const isShippingPauseOrder = /* GraphQL */ `
  mutation UpdateStore($input: UpdateStoreInput!) {
    updateStore(input: $input) {
      id
      isShippingPaused
      storeName
    }
  }
`;

export const isPickupPauseOrder = /* GraphQL */ `
  mutation UpdateStore($input: UpdateStoreInput!) {
    updateStore(input: $input) {
      id
      isPickupPaused
      storeName
    }
  }
`;

export const deleteStore = /* GraphQL */ `
  mutation DeleteStore($input: DeleteStoreInput!) {
    deleteStore(input: $input) {
      id
    }
  }
`;

export const deletePhoto = /* GraphQL */ `
  mutation deletePhoto($input: DeletePhoto!) {
    deletePhoto(input: $input)
  }
`;

export const bulkDeleteStore = /* GraphQL */ `
  mutation deleteStoreBulk($input: DeleteStoreBulkInput!) {
    deleteStoreBulk(input: $input) {
      returnedIds
    }
  }
`;

export const createUserWest = /* GraphQL */ `
  mutation createUserWest($input: CreateUserWestInput!) {
    createUserWest(input: $input)
  }
`;

export const updateUserWest = /* GraphQL */ `
  mutation updateUserWest($input: UpdateUserWestInput!) {
    updateUserWest(input: $input)
  }
`;

export const updateEmailVerification = /* GraphQL */ `
  mutation updateEmailVerification($input: UpdateEmailVerificationInput!) {
    updateEmailVerification(input: $input)
  }
`;

export const updatePhoneVerification = /* GraphQL */ `
  mutation updatePhoneVerification($input: UpdatePhoneVerificationInput!) {
    updatePhoneVerification(input: $input)
  }
`;

export const updateForgetPassword = /* GraphQL */ `
  mutation updateForgetPassword($input: UpdateForgetPasswordInput!) {
    updateForgetPassword(input: $input)
  }
`;

export const confirmSignup = /* GraphQL */ `
  mutation confirmSignup($input: ConfirmSignupInput!) {
    confirmSignup(input: $input)
  }
`;
export const getPDFDownload = /* GraphQL */ `
  mutation getPDFDownload($shipmentId: String!, $userId: String!) {
    getPDFDownload(shipmentId: $shipmentId, userId: $userId)
  }
`;

export const deleteMerchantUserProfile = /* GraphQL */ `
  mutation deleteMerchantUserProfile($input: DeleteMerchantUserProfileInput!) {
    deleteMerchantUserProfile(input: $input) {
      userId
      userRole
      merchantAccountId
    }
  }
`;

export const calculateTaxQuery = /* GraphQL */ `
  mutation calculateTax($input: [OrderShipmentInput]) {
    calculateTax(input: $input) {
      calculateTax
      calculatedStripeTaxId
      calculatedStripeTaxVal
    }
  }
`;

export const createPaymentIntentQuery = /* GraphQL */ `
  mutation createPaymentIntent($input: CreatePaymentIntentInput!) {
    createPaymentIntent(input: $input) {
      publicKey
      clientSecret
      id
      stripeCustomerId
    }
  }
`;
export const createStoreCustomerPaymentIntent = /* GraphQL */ `
  mutation createStoreCustomerPaymentIntent($input: CreatePaymentIntentInput!) {
    createStoreCustomerPaymentIntent(input: $input) {
      publicKey
      clientSecret
      id
      stripeCustomerId
    }
  }
`;

export const createPaymentLink = /* GraphQL */ `
  mutation createPaymentLink($input: createPaymentLinkInput!) {
    createPaymentLink(input: $input) {
      sessionId
      paymentntentId
    }
  }
`;

export const createFinancialReports = /* GraphQL */ `
  mutation createFinancialReports($input: createFinancialReportsInput!) {
    createFinancialReports(input: $input) {
      body
      statusCode
    }
  }
`;

export const downloadFinancialReports = /* GraphQL */ `
  mutation downloadFinancialReports($input: DownloadReportsInput!) {
    downloadFinancialReports(input: $input)
  }
`;
export const generateFinancialReportsInvoice = /* GraphQL */ `
  mutation generateFinancialReportsInvoice($input: createFinancialReportsInput!) {
   generateFinancialReportsInvoice(input: $input) {
      body
      statusCode
    }
  }
`; 
export const confirmCheckoutSession = /* GraphQL */ `
  mutation confirmCheckoutSession($input: confirmCheckoutSessionInput!) {
    confirmCheckoutSession(input: $input) {
      status
      stripeCustomerId
      paymentIntentId
    }
  }
`;

export const cancelPaymentIntentQuery = /* GraphQL */ `
  mutation cancelPaymentIntent($input: CancelPaymentIntentInput!) {
    cancelPaymentIntent(input: $input) {
      clientSecret
      id
      success
    }
  }
`;

export const refundPayment = /* GraphQL */ `
  mutation refundPayment($input: RefundPaymentInput!) {
    refundPayment(input: $input) {
      id
      status
      amount
      refundRes
    }
  }
`;

export const prepareCheckout = /* GraphQL */ `
  mutation prepareCheckout($input: PrepareCheckoutInput) {
    prepareCheckout(input: $input){
      cart {
        anonymousId
        belongsTo
        channel
        id
        orderStatus
        totalAmount
        totalDeliveryCharges
        totalDiscount
        totalProductAmount
        totalTaxAmount
        totalTipAmount
        transactionId
        userAgent
        userId
        cartShipment {
          nextToken
          items {
            assignedStoreId
            assignedStoreName
            cartId
            deliveryType
            deliveryFee
            deliveryFeeConfig
            {
              from
              to
              deliveryFee
            }
            discount
            autoDiscount
            saleDiscount
            creditCardProcessingPercent
            creditCardProcessingFlatFee
            id
            shipmentStatus
            subOrderAmount
            subTotalDeliveryCharges          
            subTotal1800platformfee
            subTotalCardProcessingFee
            merchantFeeToCustomer
            subTotalAmount
            subTotalSaleAmount
            subTotalDiscount
            subTotalProductAmount
            discountSubTotalProductAmount
            subTotalTax
            subTotalTipAmount
            updatedBy
            userId
            deliveryAddress {
              addrLine1
              addrLine2
              city
              country
              latitude
              longitude
              postCode
              state
            }
            lineItems {
              id
              prodShortDesc
              upc
              productId
              productName
              qtyPurchased
              size
              itemInvalid
              totalPrice
              totalSalePrice
              salePrice
              unitPrice
              uom
              storeItemId
              storeItemDesc
              storePosName
              storeSizeUom
              prodCategory
              storeDisplayQty
              availableQty
              imageSrc
              sortedData
              discountQtyPurchased
              discountUnitPrice
              discountTotalPrice
              discount
              attributes
              containerType
	            packUnits
              storeItemQty
            }
          }
        }
      }

      stores{
        Item{
          id
          storeName
          businessHours {
            Mon
            Tue
            Wed
            Thu
            Fri
            Sat
            Sun
          }
          deliveryHours {
            Mon
            Tue
            Wed
            Thu
            Fri
            Sat
            Sun
          }
          scheduleHours {
            Mon
            Tue
            Wed
            Thu
            Fri
            Sat
            Sun
          }
          deliveryFee
          isDeliveryPaused
          isPickupPaused
          destinationAccountID
          isPickupOutOfState
          deliveryFeeConfig
            {
              from
              to
              deliveryFee
            }
            doorDashDeliveryFeeConfig
            {
              from
              to
              deliveryFee
            }
          merchantFeeToCustomer
          customerConvenienceFeePercentage
          merchantConvenienceFeePercentage
          enableMerchantConvenienceFeePercentage
          enableConvenienceFeePercentage
          merchantFeeConfig{
          from
          to
          merchantFee
          merchantFeeToCustomer
          }
          merchantAccountId
          creditCardProcessingPercent
          creditCardProcessingFlatFee
          deliveryScope {
            MinOrderSize
            deliveryType
            serviceArea
          }
          address {
            addrLine1
            addrLine2
            city
            latitude
            longitude
            postCode
            state
          }
          isDeliveryPaused
          isPickupPaused
          orderFulfilling {
            pickUp
            delivery
            gifting
          }
        }
      }
      paymentIntent{
        publicKey
        clientSecret
        id
      }
         taxCalculation{
          calculatedTax
          calculatedStripeTaxId
          calculatedStripeTaxVal
        }
      errorMessage
    }
  }
  `;

export const updateCustomerProfile = /* GraphQL */ `
  mutation updateCustomerProfile($input: UpdateCustomerProfileInput!) {
    updateCustomerProfile(input: $input) {
      userId
      deliveryToId
      myReferralCode
      firstName
      lastName
      middleName
      email
      phoneNumber
    }
  }
`;

export const createReports = /* GraphQL */ `
  mutation createReports($input: CreateReportsInput!) {
    createReports(input: $input) {
      body
      statusCode
    }
  }
`;
export const createLoyalOrderReports = /* GraphQL */ `
  mutation createLoyalOrderReports($input: CreateLoyalOrderReportsInput!) {
    createLoyalOrderReports(input: $input) {
      body
      statusCode
    }
  }
`;

export const createUnmappedReports = /* GraphQL */ `
  mutation createUnmappedReports($input: CreateUnmappedInput!) {
    createUnmappedReports(input: $input) {
      body
      statusCode
    }
  }
`;

export const downloadReports = /* GraphQL */ `
  mutation downloadReports($input: DownloadReportsInput!) {
    downloadReports(input: $input)
  }
`;
export const downloadLoyalOrderReports = /* GraphQL */ `
  mutation downloadLoyalOrderReports($input: DownloadReportsInput!) {
    downloadLoyalOrderReports(input: $input)
  }
`;

export const downloadUnmappedReports = /* GraphQL */ `
  mutation downloadUnmappedReports($input: DownloadReportsInput!) {
    downloadUnmappedReports(input: $input)
  }
`;

export const createConnectStripeAccount = /* GraphQL */ `
  mutation createConnectStripeAccount(
    $input: createConnectStripeAccountInput!
  ) {
    createConnectStripeAccount(input: $input) {
      id
    }
  }
`;
